import React, { useState } from "react";

import { Text, Price, Img, Flex } from "flicket-ui";
import { useLaybuyPriceCalculation } from "~hooks";
import { CheckoutLaybuyModal } from "~components/checkout/financial/checkout.Laybuy.modal";
import { Integration } from "~graphql/sdk";

interface LaybuyProps {
  totalPrice: number;
  hasTicketSelected: boolean;
  laybuy: Partial<Integration>;
  showHiddenFees?: boolean;
  isSmallDisplay?: boolean;
}

const Laybuy = ({
  totalPrice,
  hasTicketSelected,
  laybuy,
  isSmallDisplay = false,
}: LaybuyProps) => {
  const [isOpen, setOpen] = useState(false);
  const { laybuyPrice } = useLaybuyPriceCalculation(totalPrice, laybuy);

  const showPrice = hasTicketSelected;

  return (
    <Flex
      onClick={() => setOpen(true)}
      alignItems={isSmallDisplay ? "flex-end" : "center"}
      justifyContent={isSmallDisplay ? "space-between" : "end"}
    >
      <Text
        cursor="pointer"
        fontWeight="medium"
        display={isSmallDisplay ? "div" : "flex"}
        fontSize={isSmallDisplay ? 2 : 3}
        alignItems="center"
        color="N600"
        mr={1}
      >
        <Img
          marginLeft={isSmallDisplay ? 0 : 1}
          marginRight={1}
          width={80}
          display="block"
          src="/static/laybuy.svg"
        />{" "}
        6 weekly interest free payments from{" "}
      </Text>

      <Text
        fontWeight="medium"
        fontSize={isSmallDisplay ? 2 : 3}
        // @ts-expect-error overriding theme styles
        marginBottom={isSmallDisplay ? "1px" : 0}
        lineHeight={"18px" as any}
        color="N800"
      >
        {showPrice ? <Price price={laybuyPrice} /> : "-"}
      </Text>

      <CheckoutLaybuyModal
        isOpen={isOpen}
        onClose={() => {
          setOpen(!isOpen);
        }}
      />
    </Flex>
  );
};

export default Laybuy;
